import Cookie from "js-cookie";
import { navigate } from "@/utils/navigation";
import { resetAppState } from "@/store/actions";
import { request } from "@/utils/api/legacyRequest";
import { apolloClient } from "@/apollo/client";
import { clearSessionId } from "@/analytics";

export function deleteSession() {
  return (dispatch, getState) => {
    const { user } = getState();
    const userId = user.get("id");
    const jwt = user.get("jwt");
    const logoutURL = `${window?.env?.VITE_API_ENDPOINT || import.meta.env.VITE_API_ENDPOINT
      }/api/auth/logout/${userId}`;
    Cookie.remove("token");
    // The API call is best-effort. The cookie is already gone, and the session
    // can legitimately be rejected — an account locked by a deletion request
    // still has to be able to log itself out — so the client-side cleanup runs
    // whether or not the request succeeds.
    request(logoutURL, jwt, "DELETE")
      .catch((err) => console.error(err))
      .finally(() => {
        // resetAppState only clears Redux. Apollo keeps its own InMemoryCache,
        // which survives this navigation and would still hold the previous
        // user's GraphQL data (alerts, hub reporting) for whoever logs in next
        // in the same tab.
        apolloClient.clearStore().catch((err) => console.error(err));
        // Same reasoning as the Apollo cache: the analytics session id lives in
        // sessionStorage and would otherwise carry across the logout, attributing
        // the next person in this tab to the previous user's session.
        clearSessionId();
        navigate("/");
        dispatch(resetAppState());
      });
  };
}

export function doLogout() {
  return (dispatch) => {
    // clear state
    dispatch(deleteSession());
  };
}
